import * as _ from 'lodash';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { AuthService } from 'app/router-wrapper/services/auth/auth.service';
import { Subject } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { Store } from '@ngrx/store';
import { ModalSwitchOrganizationService } from 'app/router-wrapper/services/modal-switch-organization/modal-switch-organization.service';
import { switchOrgUser } from 'app/dashboard/features/dashboard.actions';

@Component({
  selector: 'app-switch-organization',
  templateUrl: './switch-organization.component.html',
  styleUrls: ['./switch-organization.component.scss']
})
export class SwitchOrganizationComponent implements OnInit, OnDestroy {

  public form: UntypedFormGroup = new UntypedFormGroup({
    organization: new UntypedFormControl(null, [])
  });

  public access = [];
  public accessText = "";

  public organizations = [];
  public organization = null;

  public data: any = null;

  public takeUntilSubject: Subject<any> = new Subject();

  constructor(
    public authService: AuthService,
    public cookieService: CookieService,
    public modalSwitchOrganizationService: ModalSwitchOrganizationService,
    public store: Store
  ) {
  }

  ngOnInit(): void {
    const { access, orgId, userOrgs } = this.data;
    this.organizations = userOrgs.filter(userOrg => userOrg.OrgId !== orgId);
    this.organizations = _.sortBy(this.organizations, ['name']);

    this.organization = userOrgs.find(userOrg => userOrg.OrgId === orgId);

    const organization = this.organizations[0];
    this.form.get("organization").setValue(organization);

    this.access = access;

    const list = [];
    for(let permision of access) {
      switch(permision) {
        case 1:
          list.push("Account admin");
          break;
        case 2:
          list.push("Campaign Manager");
          break;
        case 3:
          list.push("Event Manager");
          break;
        case 4:
          list.push("Finance");
          break;
      }
    }
    this.accessText = `${list.join(", ")}`;
  }

  ngOnDestroy(): void {
    this.takeUntilSubject.next(null);
    this.takeUntilSubject.complete();

    this.modalSwitchOrganizationService.modalRef = null;
  }

  onSwitch() {
    const { OrgId: destOrgId } = this.form.get("organization").value;
    this.store.dispatch({
      type: switchOrgUser.type,
      payload: { destOrgId }
    });
    this.modalSwitchOrganizationService.close();
  }

  onClose() {
    this.modalSwitchOrganizationService.close()
  }

}
